
export const getIsoDateStr = (date) => {
    //return only the date part of the ISO string that is 2021-09-01
    const dateObj = new Date(date);
    return dateObj.toISOString().split("T")[0];
}